export const MAX_EMPTY_FOLLOWING_PAGES = 3;

const cursorIdentity = (cursor) => {
  if (!cursor) return null;
  if (typeof cursor === "string") return cursor;
  return cursor.id || cursor.path || cursor.ref?.path || cursor;
};

export function resolveTimelinePageState({
  itemCount = 0,
  nextCursor = null,
  sourceHasMore = false,
  previousCursor = null,
  feedScope = "open",
  emptyPageCount = 0,
} = {}) {
  const cursorAdvanced = Boolean(
    nextCursor && cursorIdentity(nextCursor) !== cursorIdentity(previousCursor),
  );
  const hasMore = Boolean(sourceHasMore && cursorAdvanced);
  const isEmpty = itemCount === 0;
  const continueAfterEmpty = Boolean(
    isEmpty &&
      feedScope === "follows" &&
      hasMore &&
      emptyPageCount < MAX_EMPTY_FOLLOWING_PAGES,
  );

  return {
    cursorAdvanced,
    hasMore,
    nextCursor: cursorAdvanced ? nextCursor : null,
    continueAfterEmpty,
    emptyPageCount: isEmpty
      ? continueAfterEmpty
        ? emptyPageCount + 1
        : emptyPageCount
      : 0,
  };
}

export function readDocumentScrollMetrics(browserWindow, browserDocument) {
  const scrollingElement =
    browserDocument.scrollingElement || browserDocument.documentElement;
  return {
    scrollTop: browserWindow.pageYOffset || scrollingElement.scrollTop || 0,
    viewportHeight:
      browserWindow.innerHeight || scrollingElement.clientHeight || 0,
    scrollHeight: scrollingElement.scrollHeight || 0,
  };
}

export function isNearDocumentBottom(
  { scrollTop = 0, viewportHeight = 0, scrollHeight = 0 } = {},
  threshold = 500,
) {
  return scrollTop + viewportHeight > scrollHeight - threshold;
}

export function canHandleFeedDocumentScroll({
  lifecycleActive = false,
  disposed = false,
  overlayActive = false,
} = {}) {
  return Boolean(lifecycleActive && !disposed && !overlayActive);
}

export function isCurrentFeedRequest({
  generation,
  currentGeneration,
  lifecycleActive = false,
  disposed = false,
} = {}) {
  return Boolean(
    !disposed && lifecycleActive && generation === currentGeneration,
  );
}

export function resolveFeedActivationAction({
  resumeRequest = null,
  wasDeactivated = false,
  itemCount = 0,
  hasPaginationIntent = false,
  hasMore = false,
} = {}) {
  if (!wasDeactivated) return null;
  if (resumeRequest === "initial" || resumeRequest === "next") {
    return resumeRequest;
  }
  if (itemCount === 0) return "initial";
  if (hasPaginationIntent && hasMore) return "check-bottom";
  return null;
}
